var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"alert"}},[_c('div',{staticClass:"alert"},[_c('div',{staticClass:"alert__box"},[_c('p',{staticClass:"alert__txt"},[_vm._v(_vm._s(_vm.errorMessage))]),_c('p',{staticClass:"alert__boar boar-img"})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }